import { RefundRequestDTO, RefundsResponseDTO } from 'api-models'
import { RefundsRange } from 'pages/workspace/asset/refunds/types'
import { InvalidTrafficPanel } from './invalid-traffic-panel'
import { OverviewPanel } from './overview-panel'
import { SubmissionHistoryTable } from './submission-history-table'
import './standard-view.css'

interface StandardViewProps {
	data: RefundsResponseDTO
	accountName: string
	range: RefundsRange
	onRangeChange: (r: RefundsRange) => void
	onRefresh: () => void
	refreshing?: boolean
	onView: (item: RefundRequestDTO) => void
}

/** §5 Standard View — Overview + Reported Invalid Traffic + Submission history. Spec B5. */
export const StandardView = ({
	data,
	accountName,
	range,
	onRangeChange,
	onRefresh,
	refreshing,
	onView
}: StandardViewProps) => {
	return (
		<div className="space-y-6">
			<div className="grid grid-cols-1 lg:grid-cols-[minmax(0,492px)_minmax(0,1fr)] gap-6 items-stretch">
				<OverviewPanel summary={data.summary} />
				<InvalidTrafficPanel
					byDay={data.by_day}
					range={range}
					onRangeChange={onRangeChange}
				/>
			</div>
			<SubmissionHistoryTable
				items={data.items}
				availableMonths={data.available_months}
				accountName={accountName}
				onRefresh={onRefresh}
				refreshing={refreshing}
				onView={onView}
			/>
		</div>
	)
}
